import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Form,
  Row,
  Col,
  Button,
  ButtonGroup,
  Alert,
  Table,
} from "react-bootstrap";
import Select from "react-select";
import Axios from "axios";
import { urlAPI } from "Common";
import Center from "react-center";
import moment from "moment";
import * as Icons from "react-feather";
import Checkbox from "components/@vuexy/checkbox/CheckboxesVuexy";

const initSearchState = {
  type: null,
  nomor: "",
  kodekel: "",
  // jaminan: "",
  noasuransi: "",
  tgllahir: null,
};

export default function Step3Page(props) {
  const {
    dataStep1,
    dataStep2,
    dataStep3,
    setDataStep3,
    initStep3,
    setMessageState,
    setShowFailed,
    handlePrev,
    handleNext,
    dataBPJS,
    dataRujukan,
    setDataRujukan,
    noBPJS,
    setNoBPJS,
    unitJenis3,
    setSEP,
    SEP,
    setSuratKontrol,
    suratKontrol,
  } = props;
  const [searchState, setSearchState] = useState(initSearchState);
  const [pasienState, setPasienState] = useState("");
  const [selected, setSelected] = useState([]);
  const [selectedPaket, setSelectedPaket] = useState([]);
  const [selectedType, setSelectedType] = useState([]);

  const [typeSelector] = useState([
    { value: "norm", label: "Nomor Rekam Medik (NORM)" },
    { value: "noktp", label: "Nomor Induk Kependudukan (NIK/NO.KTP)" },
    { value: "nik", label: "Nomor Induk Karyawan (NIK)" },
    { value: "nobpjs", label: "Nomor BPJS" },
  ]);
  const [optionsType, setOptionsType] = useState([
    { value: "norm", label: "Nomor Rekam Medik (NORM)" },
    { value: "noktp", label: "Nomor Induk Kependudukan (NIK/NO.KTP)" },
    { value: "nik", label: "Nomor Induk Karyawan (NIK)" },
    { value: "nobpjs", label: "Nomor BPJS" },
  ]);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [selectorKodeKel] = useState([
    { value: "", label: "Karyawan" },
    { value: "20", label: "Suami / Istri" },
    { value: "21", label: "Anak Pertama" },
    { value: "22", label: "Anak Kedua" },
    { value: "23", label: "Anak Ketiga" },
    { value: "24", label: "Anak Keempat" },
    { value: "25", label: "Anak Kelima" },
    { value: "26", label: "Anak Keenam" },
    { value: "27", label: "Anak Ketujuh" },
    { value: "28", label: "Anak Kedelapan" },
    { value: "29", label: "Anak Kesembilan" },
  ]);
  const [selectorJaminan] = useState([
    { value: "umum", label: "Pasien Umum" },
    { value: "bpjs", label: "BPJS" },
    { value: "prokespen", label: "Prokespen" },
    { value: "lain", label: "Asuransi Lain / Perusahaan Lain" },
    { value: "pg", label: "Petrokimia Gresik" },
  ]);

  const [options, setOptions] = useState([
    { value: "umum", label: "Pasien Umum" },
    { value: "bpjs", label: "BPJS" },
    { value: "prokespen", label: "Prokespen" },
    { value: "lain", label: "Asuransi Lain / Perusahaan Lain" },
    { value: "pg", label: "Petrokimia Gresik" },
  ]);
  const [inputNoBPJS, setInputNoBPJS] = useState("");
  const [internal, setInternal] = useState(false);
  const [selectorPaket, setSelectorPaket] = useState([]);

  const fetchDataPasien = () => {
    Axios.get(
      urlAPI +
        "/public/pasien/fetchPasienLama?params=" +
        JSON.stringify({
          isBPJS: dataStep3?.jaminan === "bpjs" ? true : false,
          sbu: dataStep1?.sbu,
          dataPasien: {
            type: searchState?.type,
            nomor: searchState?.nomor,
            kodekel: searchState?.kodekel,
            tgllahir: moment(searchState?.tgllahir)?.format("YYYY-MM-DD"),
            nobpjs: inputNoBPJS,
          },
          unitJenis3: unitJenis3,
          tanggal: moment(dataStep1?.date).format("YYYY-MM-DD"),
        })
    )
      .then((response) => {
        if (response?.data?.result?.rows?.length === 1) {
          setPasienState(response?.data?.result?.rows[0]);
          setDataStep3({
            ...dataStep3,
            norm: response?.data?.result?.rows[0]?.NORM,
            nama: response?.data?.result?.rows[0]?.NAMA,
            tgllahir: response?.data?.result?.rows[0]?.TGLLAHIR,
            namacust: response?.data?.result?.rows[0]?.NAMACUST,
            noktp: response?.data?.result?.rows[0]?.NOKTP,
          });
          setLoadingSearch(false);
          if (response?.data?.result?.rujukanBPJS?.length > 0) {
            let tempRujukan = response?.data?.result?.rujukanBPJS.filter(
              (filter) =>
                Number(moment(filter?.tglKunjungan).format("YYYYMMDD")) >=
                  Number(moment().subtract(90, "days").format("YYYYMMDD")) &&
                Number(moment(filter?.tglKunjungan).format("YYYYMMDD")) <=
                  Number(moment().format("YYYYMMDD"))
              // && filter?.poliRujukan?.kode === dataBPJS?.kodeunitbpjs //dicomment karena untuk munculin rujukan yg beda poli
            );
            setDataRujukan(tempRujukan);
            setNoBPJS(
              dataStep3?.jaminan === "bpjs" && searchState?.type === "nobpjs"
                ? searchState?.nomor
                : dataStep3?.jaminan === "bpjs" &&
                  searchState?.type !== "nobpjs"
                ? inputNoBPJS
                : ""
            );
          } else {
            setDataRujukan([]);
            setNoBPJS("");
          }

          setSEP(response?.data?.result?.SEP?.jumlahSEP);

          setSuratKontrol(response?.data?.result?.suratKontrol);
        } else {
          setPasienState(null);
          setDataStep3({ ...initStep3, jaminan: dataStep3?.jaminan });
          setLoadingSearch(false);
          setNoBPJS("");
          setSEP(0);
        }
      })
      .catch((err) => {
        setMessageState(err?.response?.pasienState?.message ?? err?.response);
        setShowFailed(true);
        setLoadingSearch(false);
      });
  };

  const fetchSelectorPaket = () => {
    Axios.get(urlAPI + "/public/regonline/selectorpaket?sbu=" + dataStep1?.sbu)
      .then((response) => {
        // console.log('response',response);
        if (response?.data?.result?.rows?.length > 0) {
          // const pilihanNull = { value: null, label: "Pilih Paket..." };
          const selectorTemp = response?.data?.result?.rows?.map((obj) => ({
            value: obj?.kodepaket,
            label: obj?.namapaket,
            isDisabled:
              obj?.headtittle === "1" ||
              obj?.headtittle === 1 ||
              obj?.headtittle === true
                ? true
                : false,
          }));
          setSelectorPaket(selectorTemp);
          // setLoadingUnit(false);
        } else {
          setSelectorPaket([]);
          // setLoadingUnit(false);
        }
      })
      .catch((err) => {
        setMessageState(err?.response?.data?.message ?? err?.response);
        setShowFailed(true);
        // setLoadingUnit(false);
      });
  };

  const cekInternal = () => {
    Axios.get(
      urlAPI +
        "/public/pasien/cekInternal?params=" +
        JSON.stringify({
          nobpjs: searchState?.nomor,
          tanggal: moment(dataStep1?.date).format("YYYY-MM-DD"),
          kodeunit: dataStep1?.unit,
        })
    )
      .then((response) => {
        if (response?.data?.status === true) {
          fetchDataPasien();
        } else {
          setMessageState(
            <p>
              Tanggal kontrol tidak sesuai, harap konfirmasi ke poli atau
              lakukan pendaftaran langsung ke RS. <br /> <br /> <br />{" "}
              <b>
                {dataStep1?.sbu === "RSPG"
                  ? "Informasi selengkapnya: Whatsapp Layanan Pelanggan 081331706002"
                  : ""}
              </b>{" "}
            </p>
          );
          setShowFailed(true);
        }
        setLoadingSearch(false);
      })
      .catch((err) => {
        setMessageState(err?.response?.pasienState?.message ?? err?.response);
        setShowFailed(true);
        setLoadingSearch(false);
      });
  };
  /*eslint-disable */
  useEffect(() => {
    if (searchState?.nomor.trim() !== "" && searchState?.tgllahir !== null) {
      setLoadingSearch(true);
      fetchDataPasien();
    }
    fetchSelectorPaket();
    handleClearJaminan(false);
  }, []);
  /*eslint-enable */

  // console.log("searchState?.noasuransi", searchState?.noasuransi)
  // console.log("searchState?.jaminan", searchState?.jaminan)
  //console.log("searchState", searchState);
  // console.log(
  //   "datarujukan : ",
  //   dataRujukan[0]?.poliRujukan?.kode,
  //   " ",
  //   dataStep2?.kodeunitbpjs
  // );

  let hariIni = moment().format("YYYY-MM-DD");
  let maxHari =
    dataStep1?.sbu === "RSPG" && dataStep1.unit !== "P37"
      ? moment().add(2, "days").format("YYYY-MM-DD")
      : dataStep1?.sbu === "RSPG" && dataStep1.unit === "P37"
      ? moment().add(5, "days").format("YYYY-MM-DD")
      : moment().add(3, "days").format("YYYY-MM-DD");

  // const [selected, setSelected] = useState([]);
  // const [selectedType, setSelectedType] = useState([]);
// console.log('datastep2 ', dataStep2)
  const handleClearJaminan = (internal) => {
    dataStep1?.sbu == "DRIYO"
      ? setOptions(selectorJaminan)
      : setOptions(
          dataStep1.unit === "P37"
            ? selectorJaminan.filter((filter) => filter?.value === "pg")
            : dataStep1?.date > maxHari || dataStep1?.date === hariIni
            ? selectorJaminan.filter((filter) => filter?.value !== "bpjs")
            : dataStep2?.kodeunitbpjs !== "IRM" && internal === false
            ? selectorJaminan.filter((filter) => filter?.value !== "bpjs")
            : selectorJaminan
        );
    setSelected([]);
  };

  const handleClearType = (jaminan) => {
    setOptionsType(
      jaminan === "bpjs"
        ? typeSelector.filter((filter) => filter.value === "nobpjs")
        : typeSelector
    );
    setSelectedType([]);
  };

  // const handleClearType = (jaminan) => {
  //   if (jaminan === "bpjs" && dataStep1?.sbu === "DRIYO") {
  //     setOptionsType(typeSelector.filter((filter) => filter.value === "nobpjs"));
  //   } else {
  //     setOptionsType(typeSelector.filter((filter) => filter.value !== "nobpjs"));
  //   }
  //   setSelectedType([]);
  // };

  return (
    <>
      <Card.Title>
        <strong>(3/4) Data Pasien</strong>
      </Card.Title>
      <br />
      <Card>
        <Card.Body>
          <Form>
            <Row>
              <Col lg="6" md="6" sm="12">
                {/* <Checkbox
                  color="success"
                  type="switch"
                  // icon={<Icons.Check className="vx-icon" size={16} />}
                  checked={internal}
                  onClick={() => {
                    setInternal(!internal);
                    setSearchState(initSearchState);
                    setDataStep3({
                      ...dataStep3,
                      jaminan: "",
                    });
                    handleClearJaminan(!internal);
                  }}
                  label={
                    <strong style={{ color: "#F9A825" }}>
                      &nbsp;Rujuk Internal
                    </strong>
                  }
                /> */}
                {dataStep2?.kodeunitbpjs !== "IRM" ? (
                  <Form.Check // prettier-ignore
                    type="switch"
                    id="custom-switch"
                    label="Rujuk Internal"
                    checked={internal}
                    onClick={() => {
                      setInternal(!internal);
                      setSearchState(initSearchState);
                      setDataStep3({
                        ...dataStep3,
                        jaminan: "",
                      });
                      handleClearJaminan(!internal);
                    }}
                  />
                ) : (
                  <></>
                )}
              </Col>
            </Row>
            <br />
            <Row>
              <Col lg="6" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>Pilih Jaminan</Form.Label>
                  <Select
                    styles={{
                      color: "black",
                    }}
                    id="jaminan"
                    name="jaminan"
                    isDisabled={loadingSearch}
                    value={selected}
                    options={options}
                    onChange={(e) => {
                      setDataStep3({
                        ...dataStep3,
                        jaminan: e.value,
                      });
                      setSelected(e);
                      handleClearType(e.value);
                      if (e.value === "bpjs") {
                        setSearchState({
                          ...searchState,
                          tgllahir: null,
                        });
                      }
                    }}
                    // onChange={setSelected}
                  />
                </Form.Group>
              </Col>

              <Col lg="6" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>Jenis Pengenal</Form.Label>
                  <Select
                    styles={{
                      color: "black",
                    }}
                    id="jenispengenal"
                    name="jenispengenal"
                    isDisabled={loadingSearch}
                      options={
                      dataStep3?.jaminan === "prokespen"
                      ? optionsType.filter((option) => option.value !== "nobpjs") // Hilangkan opsi BPJS
                       : optionsType
                      }
                    value={selectedType}
                    onChange={(e) => {
                      setSearchState({
                        ...searchState,
                        type: e.value,
                        kodekel: "",
                      });
                      setInputNoBPJS("");
                      setSelectedType(e);
                    }}
                  />
                </Form.Group>
              </Col>
              <Col lg="6" md="6" sm="12">
                {searchState?.type === "nik" ? (
                  <Row>
                    <Col lg="8" md="8" sm="12">
                      <Form.Group className="mb-3">
                        <Form.Label>Nomor</Form.Label>
                        <Form.Control
                          type="text"
                          id="nomor"
                          name="nomor"
                          disabled={loadingSearch}
                          value={searchState?.nomor}
                          onChange={(e) =>
                            setSearchState({
                              ...searchState,
                              nomor: e.target.value,
                            })
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col lg="4" md="4" sm="12">
                      <Form.Group className="mb-3">
                        <Form.Label>Kode Kel</Form.Label>
                        <Select
                          styles={{
                            color: "black",
                          }}
                          id="kodekel"
                          name="kodekel"
                          isDisabled={loadingSearch}
                          options={selectorKodeKel}
                          value={selectorKodeKel.find(
                            (find) => find?.value === searchState?.kodekel
                          )}
                          onChange={(e) => {
                            setSearchState({
                              ...searchState,
                              kodekel: e.value,
                            });
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                ) : (
                  <Form.Group className="mb-3">
                    <Form.Label>Nomor</Form.Label>
                    <Form.Control
                      type="text"
                      id="nomor"
                      name="nomor"
                      placeholder="Masukkan Nomor Jenis Pengenal"
                      disabled={loadingSearch}
                      value={searchState?.nomor}
                      onChange={(e) =>
                        setSearchState({
                          ...searchState,
                          nomor: e.target.value,
                        })
                      }
                    />
                  </Form.Group>
                )}
              </Col>
              {dataStep3?.jaminan !== "bpjs" && (
                <Col lg="6" md="6" sm="12">
                  <Form.Group className="mb-3">
                    <Form.Label>Tanggal Lahir</Form.Label>
                    <Form.Control
                      type="date"
                      id="tgllahir"
                      name="tgllahir"
                      disabled={loadingSearch}
                      value={searchState?.tgllahir}
                      onChange={(e) =>
                        setSearchState({
                          ...searchState,
                          tgllahir: e.target.value,
                        })
                      }
                    />
                  </Form.Group>
                </Col>
              )}
            {dataStep3?.jaminan === "bpjs" &&
              searchState?.type !== "nobpjs" &&
              dataStep1?.sbu === "DRIYO" && (
                <Col lg="6" md="6" sm="12">
                  <Form.Group className="mb-3">
                    <Form.Label>Nomor BPJS</Form.Label>
                    <Form.Control
                      type="text"
                      id="nomor"
                      name="nomor"
                      placeholder="Masukkan Nomor BPJS"
                      disabled={loadingSearch}
                      value={inputNoBPJS}
                      onChange={(e) => setInputNoBPJS(e.target.value)}
                    />
                  </Form.Group>
                </Col>
            )}
            </Row>
            <Row>
              <Col className="d-none d-lg-block" lg="2">
                <div className="d-grid gap-2" style={{ paddingTop: "32px" }}>
                  <Button
                    block
                    variant="warning"
                    disabled={
                      dataStep3?.jaminan === "bpjs" &&
                      searchState?.type !== "nobpjs"
                        ? searchState?.nomor.trim() === "" ||
                          dataStep3?.jaminan === null ||
                          // dataStep3?.jaminan === "bpjs" ||
                          loadingSearch ||
                          searchState?.type === null ||
                          inputNoBPJS.trim() === ""
                        : dataStep3?.jaminan === "bpjs" &&
                          searchState?.type === "nobpjs"
                        ? searchState?.nomor.trim() === "" ||
                          dataStep3?.jaminan === null ||
                          // dataStep3?.jaminan === "bpjs" ||
                          loadingSearch ||
                          searchState?.type === null
                        : searchState?.nomor.trim() === "" ||
                          dataStep3?.jaminan === null ||
                          // dataStep3?.jaminan === "bpjs" ||
                          searchState?.tgllahir === null ||
                          loadingSearch ||
                          searchState?.type === null
                    }
                    onClick={() => {
                      setLoadingSearch(true);
                      internal === true || internal == 1
                        ? cekInternal()
                        : fetchDataPasien();
                    }}
                  >
                    {loadingSearch ? "Loading..." : "Cari"}
                  </Button>
                </div>
              </Col>
              <Col className="d-block d-lg-none" md="12" sm="12">
                <div className="d-grid gap-2">
                  <Button
                    block
                    variant="warning"
                    disabled={
                      dataStep3?.jaminan === "bpjs" &&
                      searchState?.type !== "nobpjs"
                        ? searchState?.nomor.trim() === "" ||
                          dataStep3?.jaminan === null ||
                          // dataStep3?.jaminan === "bpjs" ||
                          loadingSearch ||
                          searchState?.type === null ||
                          inputNoBPJS.trim() === ""
                        : dataStep3?.jaminan === "bpjs" &&
                          searchState?.type === "nobpjs"
                        ? searchState?.nomor.trim() === "" ||
                          dataStep3?.jaminan === null ||
                          // dataStep3?.jaminan === "bpjs" ||
                          loadingSearch ||
                          searchState?.type === null
                        : searchState?.nomor.trim() === "" ||
                          dataStep3?.jaminan === null ||
                          // dataStep3?.jaminan === "bpjs" ||
                          searchState?.tgllahir === null ||
                          loadingSearch ||
                          searchState?.type === null
                    }
                    onClick={() => {
                      setLoadingSearch(true);
                      internal === true || internal == 1
                        ? cekInternal()
                        : fetchDataPasien();
                    }}
                  >
                    {loadingSearch ? "Loading..." : "Cari"}
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
      {loadingSearch ? (
        <>
          <br />
          <Center>
            <h3>Loading...</h3>
          </Center>
        </>
      ) : (
        <>
          {pasienState === null && searchState?.nomor?.trim() !== "" ? (
            <>
              <br />
              {dataStep1.sbu === "RSPG" ? (
                <p style={{ textAlign: "center" }}>
                  Apabila ada yang ingin ditanyakan silahkan menghubungi Contact
                  Person Pendaftaran Online RS.PETROKIMIA GRESIK, HP:
                  <strong> 081331706002</strong>
                </p>
              ) : dataStep1.sbu === "GRAHU" ? (
                <p style={{ textAlign: "center" }}>
                  Apabila ada yang ingin ditanyakan silahkan menghubungi Contact
                  Person Pendaftaran Online RS.GRHA HUSADA, HP:
                </p>
              ) : dataStep1.sbu === "KALIMANTAN" ? (
                <p style={{ textAlign: "center" }}>
                  Apabila ada yang ingin ditanyakan silahkan menghubungi Contact
                  Person Pendaftaran Online KLINIK SATELIT KALIMANTAN GKB, HP:
                  <strong> 085335761099</strong>
                </p>
              ) : dataStep1.sbu === "PPK1" ? (
                <p style={{ textAlign: "center" }}>
                  Apabila ada yang ingin ditanyakan silahkan menghubungi Contact
                  Person Pendaftaran Online KLINIK PPK1 PT.PETROKIMIA, HP:
                  <strong> 085733566527</strong>
                </p>
              ) : dataStep1.sbu === "DRIYO" ? (
                <p style={{ textAlign: "center" }}>
                  Tidak ada pasien atas nomor tersebut, mohon periksa kembali
                  nomor atau jenis pengenal pasien. Apabila ada yang ingin
                  ditanyakan silahkan menghubungi Contact Person Pendaftaran
                  Online RS.PETROKIMIA DRIYOREJO, HP:
                  <strong> 081235737711</strong>
                </p>
              ) : dataStep1.sbu === "WA" ? (
                <p style={{ textAlign: "center" }}>
                  Apabila ada yang ingin ditanyakan silahkan menghubungi Contact
                  Person Pendaftaran Online KLINIK PPK1 WERINGIN ANOM, HP:
                </p>
              ) : (
                <></>
              )}
              <Center>
                <img src="assets/img/empty-1.svg" width="30%" alt="gambar" />
              </Center>
              <br />
              <p style={{ textAlign: "center" }}>
                Tidak ada pasien atas nomor tersebut, mohon periksa kembali
                nomor atau jenis pengenal pasien.
              </p>

              <br />
            </>
          ) : pasienState === "" ? (
            <>
              <br />
              <Center>
                <img src="assets/img/medic-2.svg" width="30%" alt="gambar" />
              </Center>
              <br />
              <p style={{ textAlign: "center" }}>
                Masukan nomor pengenal Pasien yang ingin didaftarkan.
              </p>
            </>
          ) : (
            <>
              <br />
              <Form.Group className="mb-3">
                <Form.Label>NAMA PASIEN</Form.Label>
                <Form.Control
                  name="NAMAPASIEN"
                  id="NAMAPASIEN"
                  type="text"
                  value={pasienState?.NAMA}
                  disabled={true}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Alamat</Form.Label>
                <Form.Control
                  name="ALAMATPASIEN"
                  id="ALAMATPASIEN"
                  type="text"
                  value={pasienState?.ALAMATPASIEN}
                  disabled={true}
                />
              </Form.Group>
              <Row>
                <Col lg="6" md="6" sm="12">
                  <Form.Group className="mb-3">
                    <Form.Label>NORM</Form.Label>
                    <Form.Control
                      name="NORM"
                      id="NORM"
                      type="text"
                      value={pasienState?.NORM}
                      disabled={true}
                    />
                  </Form.Group>
                  {/* <Form.Group className="mb-3">
                    <Form.Label>Jenis Kelamin</Form.Label>
                    <Form.Control
                      name="KELAMIN"
                      id="KELAMIN"
                      type="text"
                      value={pasienState?.KELAMIN}
                      disabled={true}
                    />
                  </Form.Group> */}
                </Col>
                <Col lg="6" md="6" sm="12">
                  <Form.Group className="mb-3">
                    <Form.Label>NIK</Form.Label>
                    <Form.Control
                      name="NIK"
                      id="NIK"
                      type="text"
                      value={pasienState?.NIK}
                      disabled={true}
                    />
                  </Form.Group>
                </Col>
                <Col lg="6" md="6" sm="12">
                  <Form.Group className="mb-3">
                    <Form.Label>Tempat, Tanggal Lahir</Form.Label>
                    <Form.Control
                      name="TTL"
                      id="TTL"
                      type="text"
                      value={
                        pasienState?.TMPTLAHIR !== null
                          ? pasienState?.TMPTLAHIR.trim() +
                            ", " +
                            moment(pasienState?.TGLLAHIR).format("DD/MM/YYYY")
                          : moment(pasienState?.TGLLAHIR).format("DD/MM/YYYY")
                      }
                      disabled={true}
                    />
                  </Form.Group>
                </Col>
                {dataStep1?.unit === "P37" ? (
                  <Col lg="6" md="6" sm="12">
                    <Form.Group className="mb-3">
                      <Form.Label>Paket</Form.Label>
                      <Select
                        styles={{
                          color: "black",
                        }}
                        id="jaminan"
                        name="jaminan"
                        value={selectedPaket}
                        options={selectorPaket}
                        onChange={(e) => {
                          setDataStep3({
                            ...dataStep3,
                            paketmcu: e.value,
                          });
                          setSelectedPaket(e);
                        }}
                      />
                    </Form.Group>
                  </Col>
                ) : (
                  <></>
                )}

                {dataStep3?.jaminan === "prokespen" ? (
                  <>
                    <Col lg="6" md="6" sm="12">
                      <Form.Group className="mb-3">
                        <Form.Label>Nomor Asuransi</Form.Label>
                        <Form.Control
                          type="text"
                          id="noasuransi"
                          name="noasuransi"
                          disabled={loadingSearch}
                          value={dataStep3?.noasuransi}
                          onChange={(e) =>
                            setDataStep3({
                              ...dataStep3,
                              noasuransi: e.target.value,
                            })
                          }
                        />
                      </Form.Group>
                    </Col>
                  </>
                ) : (
                  <Col lg="5" md="6" sm="12"></Col>
                )}

                {dataStep3?.jaminan === "bpjs" && unitJenis3 !== "PPK1" && (
                  <Form.Group>
                    <Form.Label>Rujukan BPJS</Form.Label>
                    <Table striped bordered hover responsive>
                      <thead>
                        <tr>
                          <th>Nomor</th>
                          <th>Tanggal</th>
                          <th>Rumah Sakit</th>
                          <th>Poli</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dataRujukan.length === 0 ? (
                          <tr>
                            <td colSpan={4}>
                              <p style={{ textAlight: "center" }}>
                                Jika rujukan anda masih berlaku tetapi gagal
                                untuk mendaftar online, mohon datang langsung ke
                                loket pendaftaran Rumah Sakit tujuan Anda.
                              </p>
                            </td>
                          </tr>
                        ) : (
                          <>
                            {dataRujukan?.map((obj, idx) => (
                              <tr key={idx}>
                                <td>{obj?.noKunjungan}</td>
                                <td>{obj?.tglKunjungan}</td>
                                <td>{dataStep1?.sbuname}</td>
                                <td>{obj?.poliRujukan?.nama}</td>
                              </tr>
                            ))}
                          </>
                        )}
                      </tbody>
                    </Table>
                  </Form.Group>
                )}
              </Row>

              <br />
            </>
          )}
          {dataStep3?.jaminan === "bpjs" &&
            unitJenis3 !== "PPK1" &&
            (dataBPJS?.kodeunitbpjs === null ||
              dataBPJS?.kodedokterbpjs === null) && (
              <>
                <Alert variant={"warning"}>
                  Dokter atau Poli yang anda pilih belum dapat melayani pasien
                  BPJS
                </Alert>
                <br />
              </>
            )}
          <Row>
            <Col lg="6" md="6" className="d-none d-md-block">
              <Button
                style={{ float: "left" }}
                variant="secondary"
                disabled={loadingSearch}
                onClick={() => {
                  handlePrev();
                }}
              >
                <Icons.ArrowLeft size={18} />
                Kembali Pilih Dokter
              </Button>
            </Col>
            <Col lg="6" md="6" className="d-none d-md-block">
              <Button
                style={{ float: "right" }}
                variant="primary"
                disabled={
                  pasienState !== null &&
                  searchState?.nomor?.trim() !== "" &&
                  dataStep3?.jaminan === "prokespen"
                    ? dataStep3?.noasuransi.trim() === "" ||
                      loadingSearch ||
                      pasienState === null
                    : dataStep3?.jaminan === "bpjs" && unitJenis3 !== "PPK1"
                    ? loadingSearch ||
                      pasienState === null ||
                      dataRujukan.length < 1 ||
                      noBPJS.trim() === "" ||
                      dataBPJS?.kodeunitbpjs === null ||
                      dataBPJS?.kodedokterbpjs === null
                    : dataStep3?.jaminan === null ||
                      loadingSearch ||
                      pasienState === null
                }
                onClick={() => handleNext()}
              >
                Simpan & Lanjutkan <Icons.ArrowRight size={18} />
              </Button>
            </Col>

            <Col className="d-block d-md-none" sm="12">
              <ButtonGroup style={{ width: "100%" }}>
                <Button
                  variant="secondary"
                  disabled={loadingSearch}
                  onClick={() => {
                    handlePrev();
                  }}
                >
                  <Icons.ArrowLeft size={18} />
                  Kembali
                </Button>
                &nbsp;
                {pasienState !== null && searchState?.nomor?.trim() !== "" && (
                  <Button
                    variant="primary"
                    disabled={
                      pasienState !== null &&
                      searchState?.nomor?.trim() !== "" &&
                      dataStep3?.jaminan === "prokespen"
                        ? dataStep3?.noasuransi.trim() === "" ||
                          loadingSearch ||
                          pasienState === null
                        : dataStep3?.jaminan === "bpjs" && unitJenis3 !== "PPK1"
                        ? loadingSearch ||
                          pasienState === null ||
                          dataRujukan.length < 1 ||
                          noBPJS.trim() === "" ||
                          dataBPJS?.kodeunitbpjs === null ||
                          dataBPJS?.kodedokterbpjs === null
                        : dataStep3?.jaminan === null ||
                          loadingSearch ||
                          pasienState === null
                    }
                    onClick={() => {
                      handleNext();
                    }}
                  >
                    Lanjutkan <Icons.ArrowRight size={18} />
                  </Button>
                )}
              </ButtonGroup>
            </Col>
          </Row>
        </>
      )}
    </>
  );
}
